<!--
     <PieChart
       title="My title"
       :chardata="chardata"
     >

     chardata = {
       name: 'Serie name',
       entries: [{
         name: "Chrome",
         y: 62.74,
       }],
     }
-->


<template>
  <highcharts
    :options="chart_options"
    ref="chart"
    style="width: 100%; height: 100%;"
  />
</template>


<style lang="scss">
</style>


<script>
 /* import { computed } from 'vue'; */

 export default {
   props: {
     title: {required: true},
     subtitle: {required: false},
     chardata: {required: true},
   },

   computed: {
     series() {
       return ([{
         name: this.chardata.name || 'chardata.name',
         colorByPoint: true,
         data: this.chardata.entries,
       }]);
     },

     chart_options() {
       return ({
         chart: {
           type: 'pie',
         },
         title: {
           text: '',
         },
         subtitle: {
           text: this.subtitle,
         },
         plotOptions: {
           pie: {
             allowPointSelect: true,
             cursor: 'pointer',
             dataLabels: {
               enabled: true,
               format: '{point.name}: {point.y} ({point.percentage:.1f}%)'
             },
             showInLegend: false,
           },
         },
         tooltip: {
           valueSuffix: '',
           backgroundColor: 'rgba(255, 255, 255, 0.93)'
         },
         credits: {
           enabled: false
         },
         series: [
           {
             colorByPoint: true,
             name: this.chardata.name,
             data: this.chardata.entries,
           }
         ],
       });
     },
   },
 };
</script>
